import api from './api';

// CareCoins — patient loyalty/rewards module.
// Matches CareCoinsController.cs routes (api/v1/carecoins/*) exactly.
// Note: there is deliberately no "commit redemption" call here — redemption is designed
// to be applied server-side inside the registration/settlement bill's own transaction,
// not from a standalone endpoint (see CARECOINS_DESIGN.md). This service only exposes the
// read-only preview plus wallet/ledger reads and the maker-checker adjustment workflow.
export const carecoinsService = {
  // 1. Wallet / Ledger (centre-scoped server-side; see CareCoinsService.GetWalletAsync)
  getWallet: async (patientId) => {
    const res = await api.get(`/carecoins/wallet/${patientId}`);
    return res.data;
  },

  getLedger: async (patientId, page = 1, pageSize = 20) => {
    const res = await api.get(`/carecoins/ledger/${patientId}`, { params: { page, pageSize } });
    return res.data;
  },

  // 2. Redemption preview (read-only — no mutation, server re-validates everything again
  // at actual bill-commit time)
  previewRedemption: async ({ patientId, centreId, labNo, pointsRequested }) => {
    const res = await api.post('/carecoins/redemption/preview', {
      patientId,
      centreId,
      labNo,
      pointsRequested,
    });
    return res.data;
  },

  // 3. Maker-checker manual adjustments (Accounts/Admin only — enforced server-side)
  createAdjustmentRequest: async ({ patientId, centreId, requestedPoints, reason }) => {
    const res = await api.post('/carecoins/adjustments', {
      patientId,
      centreId,
      requestedPoints,
      reason,
    });
    return res.data;
  },

  approveAdjustmentRequest: async (requestNo) => {
    const res = await api.post(`/carecoins/adjustments/${requestNo}/approve`);
    return res.data;
  },

  rejectAdjustmentRequest: async (requestNo, rejectionReason) => {
    const res = await api.post(`/carecoins/adjustments/${requestNo}/reject`, { rejectionReason });
    return res.data;
  },

  // 4. Rule configuration (Admin only)
  getRules: async (centreId = null) => {
    const res = await api.get('/carecoins/rules', { params: { centreId } });
    return res.data;
  },

  createRule: async (rulePayload) => {
    const res = await api.post('/carecoins/rules', rulePayload);
    return res.data;
  },
};

export default carecoinsService;
